// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"6bbf8c2c","5477":"716f930b","6868":"9f8522c1"}[chunkId] + ".chunk.css";
};